import { APIRoutes } from '~/types'

export default function () {
  return {
    newsletterSubscribe: async (email: string) => {
      return await $fetch(APIRoutes.HUBSPOT_CREATE_CONTACT, {
        body: { email },
        method: 'POST'
      }).catch((e) => e.data)
    },
    sendContactMessage: async (body: object) => {
      return await $fetch(APIRoutes.HUBSPOT_CREATE_CONTACT, {
        body,
        method: 'POST'
      }).catch((e) => e.data)
    }
  }
}
